import * as React from "react";

import { FormType, TicketingFormCategory } from "@simplyk/common";
import { UseFormReturn, useWatch } from "react-hook-form";

import { getDisplayGenerateReceipt, getEligibleAmountTotal } from "../../../common/helpers/rates";

import { TicketingFormData } from "./type";

// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";

export const useTicketDrawer = ({ form }: { form: UseFormReturn<TicketingFormData> }) => {
  const { control } = form;
  const ticketsPurchased = useWatch({ control, name: "ticketsPurchased" });
  const extraDonation = useWatch({ control, name: "extraDonation" }) || 0;
  const { formObject: ticketing, validDiscount, hasDiscountCodes } = useFormV2Context(FormType.Ticketing);

  const ticketingCanHaveExtraDonation = Boolean(ticketing.extraDonation);
  const ticketingHasExtraDonation = ticketingCanHaveExtraDonation && Boolean(extraDonation);

  const allTicketsSelectedNumber = React.useMemo(
    () =>
      ticketsPurchased?.reduce((prev, current) => {
        if (!current.purchasedNumber) {
          return prev;
        }
        if (current.attendeesByTicket) {
          return prev + current.attendeesByTicket * parseInt(current.purchasedNumber.toString());
        }
        return prev + parseInt(current.purchasedNumber.toString());
      }, 0) || 0,
    [ticketsPurchased]
  );

  const isMembershipV2 = ticketing.formCategory === TicketingFormCategory.MembershipV2;

  const eligibleAmountTotal = getEligibleAmountTotal(
    ticketsPurchased,
    ticketing,
    extraDonation,
    validDiscount,
    validDiscount?.selectedRateIds ?? []
  );
  const displayGenerateReceipt =
    getDisplayGenerateReceipt(ticketsPurchased, ticketing, extraDonation) &&
    Boolean(ticketing?.organization?.canGenerateReceipt);

  return {
    hasDiscountCodes,
    ticketingCanHaveExtraDonation,
    ticketingHasExtraDonation,
    allTicketsSelectedNumber,
    isMembershipV2,
    eligibleAmountTotal,
    displayGenerateReceipt,
    extraDonation,
  };
};
